
export const getStutusCodeErrors = (status: string) => {
    switch (status) {
        case "503":
            return {isSuccessful: false, errorCode: "MAINTENANCE_TAKE_DOWN", errorMessage: "We're currently undergoing scheduled maintenance. We will be back online soon!"};
        default:
            return {isSuccessful: false, errorCode: "INTERNAL_ERROR", errorMessage: "Something went wrong while processing your request, please try again later."};
    }
} 
